import { K as KeyboardEventKey } from './keyboard-event-key.enum-2f6c4d91.js';

const BxfCardGroupConstants = {
    CARD: 'bxf-card',
    CARD_GROUP: 'bxf-card-group',
    CARD_GROUP_CONTAINER: 'bxf-card-group__container',
};

var BxfCardBackgroundColor;
(function (BxfCardBackgroundColor) {
    BxfCardBackgroundColor["WHITE"] = "white";
    BxfCardBackgroundColor["GRAY_20"] = "gray-20";
    BxfCardBackgroundColor["GRAY_50"] = "gray-50";
})(BxfCardBackgroundColor || (BxfCardBackgroundColor = {}));

var BxfCardHeaderType;
(function (BxfCardHeaderType) {
    BxfCardHeaderType["HEADER_LEFT"] = "left";
    BxfCardHeaderType["HEADER_RIGHT"] = "right";
    BxfCardHeaderType["HEADER_LEFT_RIGHT"] = "left-right";
})(BxfCardHeaderType || (BxfCardHeaderType = {}));

var BxfCardStackedType;
(function (BxfCardStackedType) {
    BxfCardStackedType["VERTICAL"] = "vertical";
    BxfCardStackedType["HORIZONTAL"] = "horizontal";
    BxfCardStackedType["NONE"] = "none";
})(BxfCardStackedType || (BxfCardStackedType = {}));

var BxfCardType;
(function (BxfCardType) {
    BxfCardType["SIMPLE"] = "simple";
    BxfCardType["CLICKABLE"] = "clickable";
    BxfCardType["SELECTABLE"] = "selectable";
    BxfCardType["COLLAPSE_VERTICAL"] = "collapse-vertical";
    BxfCardType["COLLAPSE_HORIZONTAL"] = "collapse-horizontal";
    BxfCardType["CLICKABLE_COLLAPSE_VERTICAL"] = "clickable-collapse-vertical";
    BxfCardType["CLICKABLE_COLLAPSE_HORIZONTAL"] = "clickable-collapse-horizontal";
    BxfCardType["SELECTABLE_COLLAPSE_VERTICAL"] = "selectable-collapse-vertical";
    BxfCardType["SELECTABLE_COLLAPSE_HORIZONTAL"] = "selectable-collapse-horizontal";
})(BxfCardType || (BxfCardType = {}));

const BxfCardConstants = {
    CARD: 'bxf-card',
    CARD_CLICKABLE: 'bxf-card__clickable',
    CARD_SELECTED: 'bxf-card__selected',
    CARD_COLLAPSED_VERTICAL: 'bxf-card__collapsed--vertical',
    CARD_COLLAPSED_HORIZONTAL: 'bxf-card__collapsed--horizontal',
    NO_BORDER: 'bxf-card__no-border',
    CARD_BORDER: 'bxf-card__border',
    CARD_ROUNDED_BORDER: 'bxf-card__rounded',
    CARD_HEADER: 'bxf-card__header',
    CARD_HEADER_LEFT_RIGHT: 'bxf-card__header--left-right',
    CARD_HEADER_RIGHT_SLOT: 'bxf-card-slot__right-only',
    CARD_HEADER_LEFT_SLOT: 'bxf-card-slot__left-only',
    CARD_HEADER_CONTAINER: 'bxf-card__header-container',
    CARD_HEADER_CONTAINER_RIGHT: 'bxf-card__header-container--right',
    CARD_HEADER_CONTAINER_LEFT_RIGHT: 'bxf-card__header-container--left-right',
    CARD_HEADER_COLLAPSED_LEFT: 'header-collapsed-left',
    CARD_HEADER_COLLAPSED_RIGHT: 'header-collapsed-right',
    DEFAULT_PADDING: '12',
    DEFAULT_BACKGROUND_COLOR: 'bxf-card__default-color',
    GRAY_20_BACKGROUND_COLOR: 'bxf-card__gray-20-color',
    GRAY_50_BACKGROUND_COLOR: 'bxf-card__gray-50-color',
    SLOT_CONTENT: 'content',
    CARD_CONTENT_CONTAINER: 'bxf-card__content-container',
    CARD_CONTENT_CONTAINER_FULL_HEIGHT_WIDTH: 'bxf-card_content-container--full-height-width',
    CARD_COLLAPSE_BUTTON_CONTAINER_VERTICAL_HEADER_RIGHT: 'bxf-card__collapse-button-container--vertical-header-right',
    CARD_COLLAPSE_BUTTON_CONTAINER_VERTICAL_HEADER_LEFT: 'bxf-card__collapse-button-container--vertical-header-left',
    CARD_COLLAPSE_BUTTON_CONTAINER_HORIZONTAL: 'bxf-card__collapse-button-container--horizontal',
    CARD_COLLAPSE_BUTTON_CONTAINER_HORIZONTAL_LEFT_RIGHT: 'bxf-card__collapse-button-container--horizontal-left-right',
    CARD_COLLAPSE_BUTTON_LABEL_CONTAINER_VERTICAL: 'bxf-card__collapse-button--vertical-label-container',
    CARD_COLLAPSE_BUTTON_LABEL_CONTAINER_HORIZONTAL: 'bxf-card__collapse-button--horizontal-label-container',
    CARD_COLLAPSE_BUTTON_LABEL_CONTAINER_HORIZONTAL_LEFT_RIGHT: 'bxf-card__collapse-button--horizontal-label-container-left-right',
    CARD_CONTENT_CONTAINER_COLLAPSED_HEIGHT: 'bxf-card__container-collapsed-height',
    CARD_CONTENT_CONTAINER_COLLAPSED_WIDTH: 'bxf-card__container-collapsed-width',
    CARD_COLLAPSE_BUTTON: 'bxf-card__collapse-button',
    CARD_COLLAPSE_BUTTON_VERTICAL: 'bxf-card__collapse-button--vertical',
    CARD_COLLAPSE_BUTTON_HORIZONTAL: 'bxf-card__collapse-button--horizontal',
    ARROW_UP: 'bxf-double-up',
    ARROW_DOWN: 'bxf-double-down',
    ARROW_LEFT: 'bxf-double-up',
    ARROW_RIGHT: 'bxf-double-down',
    SLOT_CONTENT_CONTAINER: 'bxf-card__content-slot-container',
    CARD_STACKED_VERTICAL: 'bxf-card__stacked--vertical',
    CARD_STACKED_HORIZONTAL: 'bxf-card__stacked--horizontal',
    CARD_CHECKBOX_CONTAINER: 'bxf-card__checkbox-container',
    CARD_CHECKBOX_CONTAINER_RIGHT: 'bxf-card__checkbox-container--right',
    CARD_CHECKBOX_CONTAINER_HORIZONTAL: 'bxf-card__checkbox-container--horizontal',
    CARD_CHECKBOX_CONTAINER_HORIZONTAL_LEFT_RIGHT: 'bxf-card__checkbox-container--horizontal-left-right',
    CARD_CHECKBOX_HORIZONTAL: 'bxf-card__checkbox--horizontal',
    CARD_CHECKBOX_CONTAINER_VERTICAL: 'bxf-card__checkbox-container--vertical',
    CARD_CHECKBOX_CONTAINER_VERTICAL_LEFT_RIGHT: 'bxf-card__checkbox-container--vertical-left-right',
    CARD_CHECKBOX_CONTAINER_HORIZONTAL_COLLAPSED: 'bxf-card__checkbox-container--horizontal-collapsed',
    CARD_CHECKBOX_CONTAINER_HORIZONTAL_COLLAPSED_LEFT_RIGHT: 'bxf-card__checkbox-container--horizontal-collapsed-left-right',
    CARD_RADIO_CONTAINER: 'bxf-card__radio-container',
    CARD_RADIO_CONTAINER_RIGHT: 'bxf-card__radio-container--right',
    COLLAPSE: 'collapse',
    CARD_DISABLED: 'bxf-card__disabled',
};

const { HEADER_LEFT, HEADER_LEFT_RIGHT, HEADER_RIGHT } = BxfCardHeaderType;
const { NO_BORDER, CARD_BORDER, CARD, CARD_STACKED_VERTICAL, CARD_STACKED_HORIZONTAL, CARD_SELECTED, CARD_HEADER_COLLAPSED_RIGHT, CARD_HEADER_COLLAPSED_LEFT, CARD_DISABLED, CARD_COLLAPSED_VERTICAL, CARD_COLLAPSED_HORIZONTAL, CARD_CLICKABLE, CARD_ROUNDED_BORDER, } = BxfCardConstants;
const collapseButtonKeyDownHandler = (event, collapse) => {
    event.stopPropagation();
    switch (event.key) {
        case KeyboardEventKey.SpaceBar:
        case KeyboardEventKey.Enter:
            event.preventDefault();
            collapse(event);
            break;
    }
};
/**
 * Re-enable focus outline when Tab pressed
 *  Enable hover state when Space pressed
 *  Turn on active styling when enter pressed
 * @param {KeyboardEvent} event keyboard event
 */
const keyDownHandler = (event, delegate) => {
    switch (event.key) {
        case KeyboardEventKey.SpaceBar:
        case KeyboardEventKey.Enter:
            event.preventDefault();
            delegate.toggleActiveStyling(true);
            if (delegate.host === document.activeElement) {
                event.stopPropagation();
                delegate.cardClicked.emit({
                    host: delegate.host,
                    srcEvent: null,
                });
            }
            break;
    }
};
const cardClickHandler = (event, delegate) => {
    if (delegate.type.toLowerCase().includes('clickable')) {
        if (event.type === 'mousedown') {
            delegate.toggleActiveStyling(true);
        }
        if (event.type === 'mouseup') {
            delegate.toggleActiveStyling(false);
        }
    }
    event.preventDefault();
    delegate.cardClicked.emit({
        host: delegate.host,
        srcEvent: null,
    });
};
const selectionChangeHandler = (event, delegate) => {
    event.preventDefault();
    delegate.isSelected = event.detail.value.checked;
    delegate.cardSelected.emit({
        host: delegate.host,
        isSelected: delegate.isSelected,
        srcEvent: null,
    });
};
const collapseHorizontal = (event, delegate) => {
    event.stopPropagation();
    delegate.isHorizontallyExpanded = !delegate.isHorizontallyExpanded;
    if (delegate.isHorizontallyExpanded) {
        delegate.expandedHorizontally.emit({
            host: delegate.host,
            isExpandedHorizontally: true,
            srcEvent: event,
        });
    }
    else {
        delegate.collapsedHorizontally.emit({
            host: delegate.host,
            isHorizontallyCollapsed: true,
            srcEvent: event,
        });
    }
};
const collapseVertical = (event, delegate) => {
    event.stopPropagation();
    delegate.isVerticallyExpanded = !delegate.isVerticallyExpanded;
    if (delegate.isVerticallyExpanded) {
        delegate.expandedVertically.emit({
            host: delegate.host,
            isExpandedVertically: true,
            srcEvent: event,
        });
    }
    else {
        delegate.collapsedVertically.emit({
            host: delegate.host,
            isVerticallyCollapsed: true,
            srcEvent: event,
        });
    }
};
const renderHeader = (header, headerLeftRight, headerLeft, headerRight) => {
    if (header === HEADER_LEFT_RIGHT)
        return headerLeftRight;
    if (header === HEADER_LEFT)
        return headerLeft;
    if (header === HEADER_RIGHT)
        return headerRight;
    return null;
};
const getHeaderLeftRight = (delegate, flag) => {
    let nameLeft = HEADER_LEFT;
    let nameRight = HEADER_RIGHT;
    if (!flag) {
        if (delegate.host.querySelector(`[slot=${CARD_HEADER_COLLAPSED_LEFT}]`)) {
            nameLeft = CARD_HEADER_COLLAPSED_LEFT;
        }
        if (delegate.host.querySelector(`[slot=${CARD_HEADER_COLLAPSED_RIGHT}]`)) {
            nameRight = CARD_HEADER_COLLAPSED_RIGHT;
        }
    }
    return { nameLeft, nameRight };
};
const getHeaderLeft = (delegate, flag) => {
    let name = HEADER_LEFT;
    if (!flag &&
        delegate.host.querySelector(`[slot=${CARD_HEADER_COLLAPSED_LEFT}]`)) {
        name = CARD_HEADER_COLLAPSED_LEFT;
    }
    return name;
};
const getHeaderRight = (delegate, flag) => {
    let name = HEADER_RIGHT;
    if (!flag &&
        delegate.host.querySelector(`[slot=${CARD_HEADER_COLLAPSED_RIGHT}]`)) {
        name = CARD_HEADER_COLLAPSED_RIGHT;
    }
    return name;
};
const getContainerCss = (delegate) => {
    const { backgroundColorClassMap } = delegate;
    const containerClasses = {};
    containerClasses[CARD] = true;
    containerClasses[CARD_ROUNDED_BORDER] = delegate.isRounded;
    containerClasses[NO_BORDER] = !delegate.hasBorder;
    containerClasses[CARD_BORDER] = delegate.hasBorder;
    containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = false;
    containerClasses[CARD_CLICKABLE] = false;
    containerClasses[CARD_SELECTED] = false;
    containerClasses[CARD_COLLAPSED_HORIZONTAL] = false;
    containerClasses[CARD_COLLAPSED_VERTICAL] = false;
    containerClasses[CARD_STACKED_VERTICAL] =
        delegate.stackedType === BxfCardStackedType.VERTICAL;
    containerClasses[CARD_STACKED_HORIZONTAL] =
        delegate.stackedType === BxfCardStackedType.HORIZONTAL;
    containerClasses[CARD_DISABLED] = false;
    switch (delegate.type) {
        case BxfCardType.CLICKABLE:
            containerClasses[CARD_SELECTED] = delegate.isActive;
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = !delegate.isActive;
            containerClasses[CARD_CLICKABLE] = true;
            break;
        case BxfCardType.SELECTABLE:
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = !delegate.isSelected;
            containerClasses[CARD_CLICKABLE] = !(delegate.isRadio || delegate.checkbox);
            containerClasses[CARD_SELECTED] = delegate.isSelected;
            containerClasses[CARD_DISABLED] = delegate.isDisabled;
            break;
        case BxfCardType.COLLAPSE_HORIZONTAL:
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = true;
            containerClasses[CARD_COLLAPSED_HORIZONTAL] =
                !delegate.isHorizontallyExpanded;
            break;
        case BxfCardType.COLLAPSE_VERTICAL:
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = true;
            containerClasses[CARD_COLLAPSED_VERTICAL] =
                !delegate.isVerticallyExpanded;
            break;
        case BxfCardType.CLICKABLE_COLLAPSE_VERTICAL:
            containerClasses[CARD_SELECTED] = delegate.isActive;
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = !delegate.isActive;
            containerClasses[CARD_CLICKABLE] = true;
            containerClasses[CARD_COLLAPSED_VERTICAL] =
                !delegate.isVerticallyExpanded;
            break;
        case BxfCardType.CLICKABLE_COLLAPSE_HORIZONTAL:
            containerClasses[CARD_SELECTED] = delegate.isActive;
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = !delegate.isActive;
            containerClasses[CARD_CLICKABLE] = true;
            containerClasses[CARD_COLLAPSED_HORIZONTAL] =
                !delegate.isHorizontallyExpanded;
            break;
        case BxfCardType.SELECTABLE_COLLAPSE_VERTICAL:
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = !delegate.isSelected;
            containerClasses[CARD_CLICKABLE] = !(delegate.isRadio || delegate.checkbox);
            containerClasses[CARD_COLLAPSED_VERTICAL] =
                !delegate.isVerticallyExpanded;
            containerClasses[CARD_SELECTED] = delegate.isSelected;
            break;
        case BxfCardType.SELECTABLE_COLLAPSE_HORIZONTAL:
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = !delegate.isSelected;
            containerClasses[CARD_CLICKABLE] = !(delegate.isRadio || delegate.checkbox);
            containerClasses[CARD_COLLAPSED_HORIZONTAL] =
                !delegate.isHorizontallyExpanded;
            containerClasses[CARD_SELECTED] = delegate.isSelected;
            break;
        default:
            containerClasses[backgroundColorClassMap[delegate.backgroundColor]] = true;
            break;
    }
    return containerClasses;
};

export { BxfCardGroupConstants as B, BxfCardBackgroundColor as a, BxfCardHeaderType as b, BxfCardStackedType as c, BxfCardType as d, collapseButtonKeyDownHandler as e, cardClickHandler as f, collapseHorizontal as g, collapseVertical as h, getHeaderLeftRight as i, getHeaderLeft as j, keyDownHandler as k, getHeaderRight as l, getContainerCss as m, BxfCardConstants as n, renderHeader as r, selectionChangeHandler as s };
